
import Vue from 'vue'
import BigNumber from 'bignumber.js'

const e18 = new BigNumber('1' + '0'.repeat(18))

class Value {
    public value = ''
    get wei() {
        const str = new BigNumber(this.value || 0)
            .times(e18)
            .integerValue(0)
            .toString(10)

        if (/^[0-9]+$/.test(str)) {
            return str
        }
        return null
    }
}

export default Vue.extend({
    data: () => {
        const session: {
            accepted: boolean
            error: Error | null
            result: Connex.Vendor.TxResponse | null
        } = { accepted: false, error: null, result: null }
        return {
            address: '',
            vet: new Value(),
            vtho: new Value,
            showProgress: false,
            session
        }
    },
    computed: {
        price() { return this.$state.price }
    },
    methods: {
        async send() {
            if (!this.vet.wei || !this.vtho.wei) {
                return
            }

            const message: Connex.Vendor.TxMessage = []
            if (this.vet.wei !== '0') {
                message.push({
                    to: this.address,
                    value: this.vet.wei,
                    data: '0x'
                })
            }
            if (this.vtho.wei !== '0') {
                const clause = this.$connex.thor
                    .account(energyContractAddress)
                    .method(energyTransferJsonABI)
                    .asClause(this.address, this.vtho.wei)
                message.push({
                    ...clause,
                    comment: `Transfer ${this.vtho.value} VTHO`
                })
            }
            if (message.length > 0) {
                this.showProgress = true
                this.session = { accepted: false, error: null, result: null }
                const session = this.session
                try {
                    session.result = await this.$connex.vendor.sign('tx', message)
                        .accepted(() => {
                            if (session === this.session) {
                                this.showProgress = true
                            }
                            session.accepted = true
                        })
                        .request()

                    if (session === this.session && this.showProgress) {
                        this.vet.value = ''
                        this.vtho.value = ''
                    }
                } catch (err) {
                    session.error = err as Error
                } finally {
                    if (session === this.session) {
                        this.showProgress = true
                    }
                }
            }

        }
    },
    created() {
        this.address = this.$route.params.address.toLowerCase()
    }
})

const energyContractAddress = '0x0000000000000000000000000000456E65726779'
const energyTransferJsonABI = {
    constant: false,
    inputs: [{
        name: '_to',
        type: 'address'
    }, {
        name: '_amount',
        type: 'uint256'
    }],
    name: 'transfer',
    outputs: [{
        name: 'success',
        type: 'bool'
    }],
    payable: false,
    stateMutability: 'nonpayable',
    type: 'function'
}
